import { CallRouteService } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCallRouteV1Service = bindHTTP(CallRouteService);
export const serviceName = 'call-route-v1' as const;
